import type { IMapTelemetry } from './types';

/**
 * Пустая реализация контракта.
 *
 * Её отдаёт реестр, пока фасад не положили, и возвращает фабрика, когда сбор выключен
 * рубильником. Так вызывающему коду не приходится проверять наличие телеметрии на каждом вызове.
 */
export const NOOP_MAP_TELEMETRY: IMapTelemetry = {
  trackMapInitialized: () => undefined,
  trackPinsRendered: () => undefined,
  startPinsUpdate: () => undefined,
  trackPinsUpdateRequestStarted: () => undefined,
  trackPinsUpdateSkipped: () => undefined,
  trackClustersRequestDuration: () => undefined,
  trackClustersSucceed: () => undefined,
  trackClustersFailed: () => undefined,
  trackClustersCancelled: () => undefined,
  trackClustersRetried: () => undefined,
  trackTileRendered: () => undefined,
  trackPinRenderErrors: () => undefined,
  trackPinsData: () => undefined,
  trackPinResultsAttempt: () => undefined,
  trackPinPopupBlocked: () => undefined,
};
